// Delegate — the headless hook moved to `@heidi/tasks/data` (OpenSpec
// `monorepo-tasks-data-core` · D2, ARCFE-945). Cohort B: this file owns the
// app reactions — the error toast, fired after the package hook's invalidate
// (ARCFE-921), and the lifted analytics dispatch. The legacy hook only fired
// analytics when the optimistic snapshot held the task (no else branch); the
// package port preserves that gate, so the delegate dispatches
// unconditionally when called.
import { toast } from '@heidi/design-system/toast';
import {
  useMutateUpdateSessionClinicalTask as useMutateUpdateSessionClinicalTaskCore,
  type UpdateSessionClinicalTaskParams,
} from '@heidi/tasks/data';

import { trackTaskStatefulEvent } from '@/lib/analytics/scribe/task';
import { TaskEventType } from '@/models/analyticsScribeModel';

export type { UpdateSessionClinicalTaskParams };

export const useMutateUpdateSessionClinicalTask = () => {
  return useMutateUpdateSessionClinicalTaskCore({
    onUpdateError: () => {
      toast({
        tone: 'destructive',
        title: 'Error updating clinical task',
        description: 'Could not update the clinical task. Please try again.',
      });
    },
    onUpdateSuccess: (data, previousTask) => {
      trackTaskStatefulEvent({
        taskEventType: TaskEventType.TaskEdited,
        prevTask: previousTask ?? {},
        nextTask: data.task,
      });
    },
  });
};
